import { filter } from '../CqlFilters/cqlFilters';

export const getPowerLinesHowerInfo = async (hoverInfo) => {
    const id = hoverInfo.object.id.split('.')[1];
    const naziv_dionice = hoverInfo.object.properties.naziv_dionice;
    const pripadnost_vodu = hoverInfo.object.properties.pripadnost_vodu;
    
    const vod_features = await filter('elektro:vod', 'pripadnost_vodu', pripadnost_vodu);
    //console.log(vod_features);
    const id_voda = vod_features ? (vod_features.length > 0 ? vod_features[0].id.split('.')[1] : null) : null;
    const izvorna_ts_voda = vod_features ? (vod_features.length > 0 ? vod_features[0].properties.izvorna_ts_voda : null) : null;

    const trafostanice_features = await filter('elektro:trafo_stanice', 'id_trafo_stanice', izvorna_ts_voda);
    const naziv_ts = trafostanice_features ? (trafostanice_features.length > 0 ? trafostanice_features[0].properties.naziv : null) : null;
    const broj_potrosaca_ts = trafostanice_features ? (trafostanice_features.length > 0 ? trafostanice_features[0].properties.broj_potrosaca : null) : null;

    const relevantInfo = {
        'ID dionice': id,
        'Naziv dionice': naziv_dionice,
        'Pripadnost vodu': pripadnost_vodu,
        'ID voda': id_voda,
        'Izvorna ts voda': izvorna_ts_voda,
        'Naziv ts': naziv_ts,
        'Broj potrošača ts': broj_potrosaca_ts,
    };

    return relevantInfo;
};